export default "__VITE_ASSET__kPlBxqyQ__"